export const DAYS_OF_WEEK = [
  { id: 1, name: "Monday", abbrev1: "M", abbrev2: "Mo", abbrev3: "Mo" },
  { id: 2, name: "Tuesday", abbrev1: "T", abbrev2: "Tu", abbrev3: "Tue" },
  { id: 3, name: "Wednesday", abbrev1: "W", abbrev2: "We", abbrev3: "Wed" },
  { id: 4, name: "Thursday", abbrev1: "T", abbrev2: "Th", abbrev3: "Thu" },
  { id: 5, name: "Friday", abbrev1: "F", abbrev2: "Fr", abbrev3: "Fri" },
  { id: 6, name: "Saturday", abbrev1: "S", abbrev2: "Sa", abbrev3: "Sat" },
  { id: 7, name: "Sunday", abbrev1: "S", abbrev2: "Su", abbrev3: "Sun" },
];

export const NOTIFIER_TYPES = {
  info: "info",
  warning: "warning",
  error: "error",
  success: "success",
};

export const SUPPORT_EMAIL = "help@seerist.com";

export const ROUTE_URLS = {
  home: "/home",
  searchLibrary: "/search/library",
  mapControls: "/map",
  mapLibrary: "/map/library",
};
